import { isFirebaseConfigured } from '@/lib/firebase';
import { AlertTriangle } from 'lucide-react';

export function ConfigNotice() {
  if (isFirebaseConfigured) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-white py-3 px-4 text-center text-sm font-medium">
      <div className="container mx-auto flex items-center justify-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        <span>
          Firebase not configured. Please add your credentials to the <code className="bg-amber-600 px-2 py-0.5 rounded">.env</code> file.
          See <a href="https://github.com/yourusername/quickfreeinvoice#setup" target="_blank" rel="noopener noreferrer" className="underline font-semibold">setup guide</a> for instructions.
        </span>
      </div>
    </div>
  );
}
